{
   document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".full-sec-slider");

    sliders.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 8000,
            breakpoints: {
                150: {
                    slidesPerView: 1.3,
                },
                576: {
                    slidesPerView: 1.7,
                },
                769: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 2,
                },
            }
        });
    });
});

}
{document.addEventListener("DOMContentLoaded", function () {

    function faqsAccordion() {
        const accordionGroups = document.querySelectorAll(".faqColmnWellness");

        accordionGroups.forEach((group) => {
            const accordionSections = group.querySelectorAll(".accordion-item");

            if (accordionSections.length > 0) {
                // Open first item
                const firstHeader = accordionSections[0].querySelector(".accordion-item-header");
                const firstBody = accordionSections[0].querySelector(".accordion-item-body");

                firstHeader.classList.add("active");
                firstBody.style.maxHeight = firstBody.scrollHeight + "px";

                // Close others
                for (let i = 1; i < accordionSections.length; i++) {
                    const otherHeader = accordionSections[i].querySelector(".accordion-item-header");
                    const otherBody = accordionSections[i].querySelector(".accordion-item-body");

                    otherHeader.classList.remove("active");
                    otherBody.style.maxHeight = 0;
                }
            }

            // Add Click Events For Each Accordion Inside This Group
            accordionSections.forEach((section) => {
                const header = section.querySelector(".accordion-item-header");
                const body = section.querySelector(".accordion-item-body");

                header.addEventListener("click", function () {
                    const activeHeader = group.querySelector(".accordion-item-header.active");

                    // Close previously active accordion inside THIS group only
                    if (activeHeader && activeHeader !== header) {
                        activeHeader.classList.remove("active");
                        activeHeader.nextElementSibling.style.maxHeight = 0;
                    }

                    // Toggle clicked accordion
                    if (!header.classList.contains("active")) {
                        header.classList.add("active");
                        body.style.maxHeight = body.scrollHeight + "px";
                    } else {
                        header.classList.remove("active");
                        body.style.maxHeight = 0;
                    }
                });
            });
        });
    }

    faqsAccordion();
});

}
 